export default __webpack_public_path__ + "static/media/upload-csv.6da6ef0d.svg";